import { render, staticRenderFns } from "./FamilyActivityTasks.vue?vue&type=template&id=9a1712c4&scoped=true&"
import script from "./FamilyActivityTasks.vue?vue&type=script&lang=ts&"
export * from "./FamilyActivityTasks.vue?vue&type=script&lang=ts&"
import style0 from "./FamilyActivityTasks.vue?vue&type=style&index=0&id=9a1712c4&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1712c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
